import { apiHeaders, apiURL } from '../services/config';

export const load = (eventIdOrSlug: string | undefined) => ({
  method: 'GET',
  credentials: 'include',
  headers: apiHeaders,
  endpoint: apiURL(`/utils/locale${eventIdOrSlug ? `?event=${eventIdOrSlug}` : ''}`),
});
